/** 
    @task: #71156 - Agro - Tela de listagem de Agro Visita
 */
<template>
    <div class="filtros-extras">
        <b-collapse class="card" :open="false">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"/>
                        {{ $t("filtros") }} 
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('multiple-select-aviso-qtd')"
                        />
                    </div>
                </div>
            </div>
            <div class="card-content">
                <div class="columns is-multiline py-2">
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(1)"
                            title="cliente"
                            :value="clienteSelected"
                            :options="clienteSelect"
                            :loading="clienteLoading"
                            @search="loadCliente"
                            @input="updateCliente"
                            label="nome"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(2)"
                            title="propriedade"
                            :value="propriedadeSelected"
                            :options="propriedadeSelect"
                            :loading="propriedadeLoading"
                            @search="loadPropriedade"
                            @input="updatePropriedade"
                            label="nome"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                            :disabled="clienteSelected.length==0"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(3)"
                            title="area"
                            :value="areaSelected"
                            :options="areaSelect"
                            :loading="areaLoading"
                            @search="loadArea"
                            @input="updateArea"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                            :disabled="propriedadeSelected.length==0"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(4)"
                            title="talhao"
                            :value="talhaoSelected"
                            :options="talhaoSelect"
                            :loading="talhaoLoading"
                            @search="loadTalhao"
                            @input="updateTalhao"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                            :disabled="areaSelected.length==0"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(6)"
                            title="cultura"
                            :value="culturaSelected"
                            :options="culturaSelect"
                            :loading="culturaLoading"
                            @search="loadCultura"
                            @input="updateCultura"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(7)"
                            title="motivo-visita"
                            :value="motivovisitaSelected"
                            :options="motivosvisitaSelect"
                            :loading="motivovisitaLoading"
                            @search="loadMotivoVisita"
                            @input="updateMotivoVisita"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(8)"
                            title="assunto-visita"
                            :value="assuntovisitaSelected"
                            :options="assuntovisitaSelect"
                            :loading="assuntovisitaLoading"
                            @search="loadAssuntoVisita"
                            @input="updateAssuntoVisita"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(9)"
                            title="agro-tipoocorrencia"
                            :value="tipoocorrenciaSelected"
                            :options="tipoocorrenciaSelect"
                            :loading="tipoocorrenciaLoading"
                            @search="loadTipoOcorrencia"
                            @input="updateTipoOcorrencia"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                            iconPosition="left"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(5)"
                            title="usuario"
                            :value="usuarioSelected"
                            :options="usuarioSelect"
                            :loading="usuarioLoading"
                            @search="loadUsuario"
                            @input="updateUsuario"
                            label="nome"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <verified-date-picker
                            :id="generateId(10)"
                            dateType="startDate"
                            v-model="dataInicio"
                            :endDate="dataFim"
                            title="data-inicio"
                            position="is-bottom-right"
                            :inForm="true"
                            @input="updateDataInicio()"
                            @onChange="updateDataInicio()"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <verified-date-picker
                            :id="generateId(11)"
                            dateType="endDate"
                            v-model="dataFim"
                            :startDate="dataInicio"
                            title="data-final"
                            position="is-bottom-right"
                            :inForm="true"
                            :addDateYears="2"
                            @input="updateDataFim()"
                            @onChange="updateDataFim()"
                        />
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import VendasClienteService from "@/services/VendasClienteService.js";
import PropriedadeService from "@/services/agro/PropriedadeService.js";
import AreaService from "@/services/agro/AreaService.js";
import TalhaoService from "@/services/agro/TalhaoService.js";
import GerenciarUsuariosService from "@/services/conta/GerenciarUsuariosService.js";
import CulturaService from "@/services/agro/CulturaService.js";
import TipoOcorrenciaService from '@/services/agro/ocorrencia/TipoOcorrenciaService';
import AssuntoRtrService from '@/services/agro/AssuntoRtrService.js';
import TipoRtrService from '@/services/agro/TipoRtrService.js';

export default {
    props: {
        limparFiltros: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            dataInicio: new Date(this.$moment().subtract(30, "days")),
            dataFim: new Date(),
            clienteService: new VendasClienteService(this.$http, this.$router),
            propriedadeService: new PropriedadeService(this.$http, this.$router),
            areaService: new AreaService(this.$http, this.$router),
            talhaoService: new TalhaoService(this.$http, this.$router),
            gerenciarUsuariosService: new GerenciarUsuariosService(this.$http, this.$router),
            culturaService: new CulturaService(this.$http, this.$router),
            MotivovisitaService: new TipoRtrService(this.$http, this.$router),
            AssuntovisitaService: new AssuntoRtrService(this.$http, this.$router),
            TipoocorrenciaService: new TipoOcorrenciaService(this.$http, this.$router),

            clienteSelect: [],
            clienteSelected: [],
            clienteLoading: false,
            propriedadeSelect: [], // uui
            propriedadeSelected: [],
            propriedadeLoading: false,
            areaSelect: [], // uui
            areaSelected: [],
            areaLoading: false,
            talhaoSelect: [], // uui
            talhaoSelected: [],
            talhaoLoading: false,
            usuarioSelect: [],
            usuarioSelected: [],
            usuarioLoading: false,
            culturaSelect: [],
            culturaSelected: [],
            culturaLoading: false,
            tipoocorrenciaSelect: [],
            tipoocorrenciaSelected: [],
            tipoocorrenciaLoading: false,
            motivosvisitaSelect: [],
            motivovisitaSelected: [],
            motivovisitaLoading: false,
            assuntovisitaSelect: [],
            assuntovisitaSelected: [],
            assuntovisitaLoading: false,
        };
    },
    watch: {
        limparFiltros(val) {
            if (val) this.limparFiltrosSelecionados();
        }
    },
    created() {
        this.updateDataInicio();
        this.updateDataFim();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name+'-filtro-'+numberId;
        },
        limparFiltrosSelecionados() {
            this.clienteSelected = [];
            this.propriedadeSelected = [];
            this.culturaSelected = [];
            this.areaSelected = [];
            this.talhaoSelected = [];
            this.usuarioSelected = [];
            this.tipoocorrenciaSelected = [];
            this.assuntovisitaSelected = [];
            this.motivovisitaSelected = [];
            this.dataInicio = new Date(this.$moment().subtract(30, "days"));
            this.dataFim = new Date();
            this.$emit("filtrosLimpos", false);
        },
        updateDataInicio() {
            this.$emit("update-filtro", {
                nomeFiltro: "inicio",
                valor: this.dataInicio,
            });
        },
        updateDataFim() {
            this.$emit("update-filtro", {
                nomeFiltro: "fim",
                valor: this.dataFim,
            });
        },
        // Cliente
        loadCliente(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)
            this.clienteLoading = true;
            this.clienteService
                .findAllCombo(query)
                .then((r) => {
                    this.clienteSelect = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(e) {
            this.clienteSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "cliente",
                valor: this.clienteSelected,
            });
            if(this.clienteSelected.length==0){
                this.propriedadeSelected = [];
                this.$emit("update-filtro", {nomeFiltro: "propriedade", valor: []});
                this.areaSelected = [];
                this.$emit("update-filtro", {nomeFiltro: "area", valor: []});
                this.talhaoSelected = [];
                this.$emit("update-filtro", {nomeFiltro: "talhao", valor: []});
            }

            this.loadPropriedade();
        },
        // Propriedade
        loadPropriedade(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.propriedadeLoading = true;
            let idsClientes = {};
            idsClientes = this.clienteSelected.map((e) => e.id);
            this.propriedadeService
                .listAllByMultipleIdsClientes(idsClientes, 300, 0, 2, query)
                .then(this.mapPropriedade)
                .then((value) => {
                    this.propriedadeSelect = value;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.propriedadeLoading = false;
                });
        },
        mapPropriedade(body) {
            return body.content.map((m) => {
                return {
                    uuid: m.uuid,
                    nome: m.situacao != 1 ? 'Inativo | '+ m.nome : m.nome,
                    situacao: m.situacao,
                    origempda: m.origempda
                };
            });
        },
        updatePropriedade(e) {
            this.propriedadeSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "propriedade",
                valor: this.propriedadeSelected,
            });

            if(this.propriedadeSelected.length==0){
                this.areaSelected = [];
                this.$emit("update-filtro", {nomeFiltro: "area", valor: []});
                this.talhaoSelected = [];
                this.$emit("update-filtro", {nomeFiltro: "talhao", valor: []});
            }

            this.loadArea();
        },
        // Area
        loadArea(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.areaLoading = true;
            let uuidsPropriedades = this.propriedadeSelected.map(e => e.uuid);

            this.areaService
                .listAllByMultipleIdsPropriedades(uuidsPropriedades, 1000, 0, 2, query)
                .then(this.mapArea)
                .then((value) => {
                    this.areaSelect = value;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.areaLoading = false;
                });
        },
        mapArea(body) {
            return body.content.map((m) => {
                return {
                    uuid: m.uuid,
                    descricao: m.situacao != 1 ? 'Inativo | '+ m.descricao : m.descricao,
                    situacao: m.situacao,
                    origempda: m.origempda
                };
            });
        },
        updateArea(e) {
            this.areaSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "area",
                valor: this.areaSelected,
            });
            if(this.areaSelected.length==0){
                this.talhaoSelected = [];
                this.$emit("update-filtro", {nomeFiltro: "talhao", valor: []});
            }

            this.loadTalhao();
        },
        // Talhoes
        loadTalhao(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.talhaoLoading = true;
            let uuidsAreas = this.areaSelected.map((e) => e.uuid);

            this.talhaoService
                .listAllByMultipleIdsAreas(uuidsAreas, 1000, 0, 2, query)
                .then(this.mapTalhao)
                .then((value) => {
                    this.talhaoSelect = value;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.talhaoLoading = false;
                });
        },
        mapTalhao(body) {
            return body.content.map((m) => {
                return {
                    uuid: m.uuid,
                    descricao: m.situacao != 1 ? 'Inativo | '+ m.descricao : m.descricao,
                    situacao: m.situacao,
                    origempda: m.origempda
                };
            });
        },
        updateTalhao(e) {
            this.talhaoSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "talhao",
                valor: e,
            });
        },
        // Usuarios -  usuarioSelect
        loadUsuario(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.usuarioLoading = true;
            this.gerenciarUsuariosService.findAllComboSituacao(2, query)
                .then(r => {
                    return r.content.map((m) => {
                        return {
                            id: m.idusuario,
                            idusuario: m.idusuario,
                            nome: m.situacao != 'A' ? 'Inativo | '+ m.nome : m.nome,
                            situacao: m.situacao
                        };
                    });
                })
                .then(r => {
                    this.usuarioSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.usuarioLoading = false;
                });
        },
        updateUsuario(e) {
            this.usuarioSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "usuario",
                valor: e,
            });
        },
        // Cultura
        loadCultura(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.culturaLoading = true;
            this.culturaService
                .findAllComboSituacao(2, query)
                .then(this.mapCultura)
                .then((value) => {
                    this.culturaSelect = value;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.culturaLoading = false;
                });
        },
        mapCultura(body) {
            return body.content.map((m) => {
                return {
                    id: m.id,
                    idtipocultura: m.idtipocultura,
                    descricao: m.situacao != 1 ? 'Inativo | '+ m.descricao : m.descricao,
                    situacao: m.situacao
                };
            });
        },
        updateCultura(e) {
            this.culturaSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "cultura",
                valor: e,
            });
        },
        // Tipo ocorrencia
        loadTipoOcorrencia(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.tipoocorrenciaLoading = true;
            this.TipoocorrenciaService
                .findAllComboSituacao(2, query)
                .then(this.mapTipoOcorrencia)
                .then((r) => {
                    this.tipoocorrenciaSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.tipoocorrenciaLoading = false;
                });
        },
        mapTipoOcorrencia(body) {
            return body.content.map((m) => {
                return {
                    id: m.id,
                    idagro_tipoocorrencia: m.idagro_tipoocorrencia,
                    descricao: m.situacao != 1 ? 'Inativo | '+ m.descricao : m.descricao,
                    icone: m.icone,
                    cor: m.cor,
                    situacao: m.situacao,
                };
            });
        },
        updateTipoOcorrencia(e) {
            this.tipoocorrenciaSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "tipoocorrencia",
                valor: e,
            });
        },
        // Motivo Visita - MotivoRtr
        loadMotivoVisita(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.motivovisitaLoading = true;
            this.MotivovisitaService
                .findAllComboSituacao(2, query)
                .then(this.mapMotivoVisita)
                .then((r) => {
                    this.motivosvisitaSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.motivovisitaLoading = false;
                });
        },
        mapMotivoVisita(body) {
            return body.content.map((m) => {
                return {
                    id: m.id,
                    idtiportr: m.idtiportr,
                    descricao: m.situacao != 1 ? 'Inativo | '+ m.descricao : m.descricao,
                    situacao: m.situacao,
                };
            });
        },
        updateMotivoVisita(e) {
            this.motivovisitaSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "motivosvisita",
                valor: e,
            });
        },
        // Assunto Visita - AssuntoRtr
        loadAssuntoVisita(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.assuntovisitaLoading = true;
            this.AssuntovisitaService
                .findAllComboSituacao(2, query)
                .then(this.mapAssuntoVisita)
                .then((r) => {
                    this.assuntovisitaSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.assuntovisitaLoading = false;
                });
        },
        mapAssuntoVisita(body) {
            return body.content.map((m) => {
                return {
                    id: m.id,
                    idassuntortr: m.idassuntortr,
                    descricao: m.situacao != 1 ? 'Inativo | '+ m.descricao : m.descricao,
                    situacao: m.situacao,
                };
            });
        },
        updateAssuntoVisita(e) {
            this.assuntovisitaSelected = e;
            this.$emit("update-filtro", {
                nomeFiltro: "assuntovisita",
                valor: e,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    overflow: initial;
    color: $darker-gray-color;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }

    .card-content {
        padding: 0.9rem;

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.filtros-extras {
    font-size: 12px;
}
.form-height {
    height: 34px;
}
</style>